import { InvoiceType } from 'graphql-query-contracts';

import { getDefaultInvoiceType } from '../../helpers/getInvoicingOptionsEnabledValue';

type Params = {
  isInvoicingOptionsFlagEnabled: boolean;
  isInvoicingDisabled: boolean;
  isInvoiceOptionsEnabled?: boolean;
};

export function initialInvoiceType({
  isInvoicingOptionsFlagEnabled,
  isInvoicingDisabled,
  isInvoiceOptionsEnabled,
}: Params): InvoiceType {
  const defaultInvoiceType = getDefaultInvoiceType(
    isInvoicingDisabled,
    isInvoiceOptionsEnabled
  );

  return isInvoicingOptionsFlagEnabled &&
    defaultInvoiceType !== InvoiceType.InvoiceTypeNoInvoice
    ? InvoiceType.InvoiceTypeMonthly
    : defaultInvoiceType;
}
